'use strict';

import template from
    '../../../../templates/settings/integrations/quickbooks/PaymentAccount.ejs';
import RowEditView from 'commons/views/RowEdit';

module.exports = RowEditView.extend({
    tagName: 'tr',

    events: function() {
        var parentEvents = _.isFunction(RowEditView.prototype.events) ?
            RowEditView.prototype.events() :
            RowEditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'change [name=remoteId]': 'setRemoteName'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: true,
            qbAccounts: []
        });
        this.options.templateExtra = {qbAccounts: this.options.qbAccounts};
        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    setRemoteName: function(ev) {
        let $input = this.$(ev.currentTarget);
        let remoteId = this.getInputValue($input);
        let remoteName = $.trim(
            $input.find(`option[value="${remoteId}"]`).text()
        );
        this.model.set({remoteName: remoteName || ''});
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/quickbooks/PaymentAccount.js